import apiClient from './client';

export const progressionApi = {
  getBelts: () =>
    apiClient.get('/progression/belts').then((r) => r.data),

  getAthleteProgression: (athleteId: string) =>
    apiClient.get(`/progression/athlete/${athleteId}`).then((r) => r.data),

  createPromotion: (data: {
    athlete_id: string;
    belt_id: string;
    stripes: number;
    promoted_by?: string;
    promotion_date: string;
    notes?: string;
  }) => apiClient.post('/progression/promotions', data).then((r) => r.data),

  getEligible: (params?: { min_days?: number; min_attendance?: number }) =>
    apiClient.get('/progression/eligible', { params }).then((r) => r.data),

  declareSelfRank: (data: {
    athlete_id?: string;
    belt_id: string;
    stripes: number;
    promotion_date?: string;
  }) => apiClient.post('/progression/self-rank', data).then((r) => r.data),
};
